/* eslint-disable */
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
  //配置
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  state: {
    username: null,
    nickname: null,
    avatar: null,
    phone: null,
    token: null,
    userInfo: null,
    auth: false,
    roleId: 0,
    roleName: null,
    storeId: 0,
    storeType: 0,
    storeName: null,
    headquarter: 0,
    sid: null,
  },
  mutations: {
    // 用户登录成功，存储 token 并设置 header 头
    LOGINED(state, data) {
      state.token = data.token;
      state.auth = true;
      sessionStorage.setItem('token', state.token);
      localStorage.setItem('token', state.token);
      localStorage.setItem('auth', true);
      localStorage.setItem('sid', state.sid);
    },
    // 用户刷新 token 成功，使用新的 token 替换掉本地的token
    REFRESH_TOKEN(state, token) {
      state.token = token;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token;
    },
    // 登录成功后拉取用户的信息存储到本地
    PROFILE(state, data) {
      state.username = data.name;
      state.nickname = data.nickname;
      state.phone = data.phone;
      state.avatar = data.avatar;
      state.storeId = data.storeId;
      state.storeType = data.storeType;
      state.storeName = data.storeName;
      state.headquarter = data.headquarter;
      state.sid = data.sid;
      if(data.roles){
        state.roleId = data.roles[0].id;
        state.roleName = data.roles[0].roleName;
      }
      localStorage.setItem('userInfo', JSON.stringify(state));
    },
    // 用户登出，清除本地数据
    LOGOUT(state){
      state.username = null;
      state.nickname = null;
      state.phone = null;
      state.avatar = null;
      state.auth = false;
      state.roleId = 0;
      state.roleName = null;
      state.token = null;
      state.storeId = 0;
      state.storeType = 0;
      state.storeName = null;
      state.headquarter = 0;
      state.sid = null;
    }
  },
  actions: {
    // 登录成功后保存用户信息
    logined({dispatch, commit}, data) {
      return new Promise(function (resolve, reject) {
        commit('LOGINED', data);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
        dispatch('profile').then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 登录成功后使用 token 拉取用户的信息
    profile({commit}) {
      return new Promise(function (resolve, reject) {
        let url = process.env.VUE_APP_ADMIN_API_URL + 'account/info'
        axios.get(url, {}).then(res => {
          let r = res.data;
          if (r.code == 200) {
            commit('PROFILE', r.result);
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    // 用户登出，清除本地数据并重定向至登录页面
    logout({commit}) {
      return new Promise(function (resolve, reject) {
        commit('logout')
        window.location.href = '/login'
        /*
        if(state.token){
          axios.get(process.env.API_URL + 'authorizations/logout', {headers:{'Authorization': state.token}}).then(respond => {
            Vue.$router.push({name:'login'})
          })
        }
        */
      })
    },
    // 将刷新的 token 保存至本地
    refreshToken({commit},token) {
      return new Promise(function (resolve, reject) {
        /*
        axios.post(process.env.API_URL + '/authorizations/current', {headers:{'Authorization': token}}).then(respond => {
          let r = respond.data
          if(r.success === 1) {
            commit('refreshToken', r.data.access_token)
          }
        })
        */
      })
    }
  },
  modules: {}
})
